import { createMachine } from 'xstate'
import { extractAllStates } from '@/composition/useXState'

import type { Typegen0 } from './PmResourceRequestUpdatePureState.typegen'

export type State = Typegen0['matchesStates']

export const PmResourceRequestUpdatePureState = createMachine({
  tsTypes: {} as import('./PmResourceRequestUpdatePureState.typegen').Typegen0,
  schema: {},

  id: 'PmResourceRequestUpdatePureState',
  initial: 'default',

  states: {
    default: {},
    save: {
      initial: 'saving',

      states: {
        saving: {},
        failed: {
          meta: {
            error: true,
            errorMessage:
              'Es gab einen unbekannten Fehler beim Aktualisieren der Ressourcen-Anfragen',
          },
        },

        success: {},
      },
    },
  },
})

export const states = extractAllStates(PmResourceRequestUpdatePureState)
